import React, { Component } from "react";
import { Collapse, Card, Col, CardBody, CardHeader, Badge, CardImg } from "reactstrap";

import { Link } from "react-router-dom";

import gantImg from '../../assets/images/plan/utjd_gant2024.png';
import objectives from '../../assets/images/plan/utjd-objectives-2023-2024.png';

class AccordionPlan extends Component {
	constructor(props) {
		super(props);
		this.state = {
            col0: false,
			col1: true,
			col2: false,
			col3: false,
            col4: false,
            col5: false,
			col6: false,
			col7: false,
            col8: false,
			col9: false,
			col10: false
		};

        this.t_col0 = this.t_col0.bind(this);
		this.t_col1 = this.t_col1.bind(this);
		this.t_col2 = this.t_col2.bind(this);
		this.t_col3 = this.t_col3.bind(this);
        this.t_col4 = this.t_col4.bind(this);
		this.t_col5 = this.t_col5.bind(this);
        this.t_col6 = this.t_col6.bind(this);
		this.t_col7 = this.t_col7.bind(this);
		this.t_col8 = this.t_col8.bind(this);
        this.t_col9 = this.t_col9.bind(this);
		this.t_col10 = this.t_col10.bind(this);
	}

    t_col0() {
        this.setState({ col0: !this.state.col0 });
    }
    t_col1() {
        this.setState({ col1: !this.state.col1 });
    }
    t_col2() {
        this.setState({ col2: !this.state.col2 });
    }
    t_col3() {
        this.setState({ col3: !this.state.col3 });
    }
    t_col4() {
        this.setState({ col4: !this.state.col4 });
    }
    t_col5() {
        this.setState({ col5: !this.state.col5 });
    }
    t_col6() {
        this.setState({ col6: !this.state.col6 });
    }
    t_col7() {
        this.setState({ col7: !this.state.col7 });
    }
    t_col8() {
        this.setState({ col8: !this.state.col8 });
    }
    t_col9() {
        this.setState({ col9: !this.state.col9 });
    }
    t_col10() {
        this.setState({ col10: !this.state.col10 });
    }

	render() {
		return (
            <Col xl={12}>
                <Card>
                    <CardBody>
                        <h4 className="card-title">Plan for Project Year 2023-2024</h4>
                        <p className="card-title-desc">
                            Please find details on main objectives for project year 2023-2024. Please click to read details.
                        </p>

                        <div id="accordion">
                            <Card className="mb-0">
                                <Link to="#" onClick={this.t_col0} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingZero">
                                    <h6 className="m-0 font-14">
                                            Gantt Chart - Overview of the Plan for team for 2023-2024 project year <Badge color="success" className="mr-1">Agreed</Badge>
                                            <i className={this.state.col0 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                                </Link>
                                <Collapse isOpen={this.state.col0}>
                                        <CardBody>
                                            Agreed Strategic plan for UTJD team for 2023-2024 project year
                                            <CardImg className="img-fluid" src={gantImg} alt="Gantt Chart for first half 2023" />
                                        </CardBody>
                                        
                                </Collapse>
                            </Card>
                            <Card className="mb-1">
                                <Link to="#" onClick={this.t_col1} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingOne">
                                    <h6 className="m-0 font-14">
                                            Item #1 - Book on Concentration Camps: 01. October 2022 <Badge color="info" className="mr-1">In Progress</Badge>
                                            <i className={this.state.col1 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                                </Link>
                                <Collapse isOpen={this.state.col1}>
                                        <CardBody>
                                            One of main priorities is to finish the Book on Concentration Camps. Therefore, the new deadline is set to 01. October 2023 to finish the report, but the publishing has to be done latest by the end of 30. September 2023
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-1">
                            <Link to="#" onClick={this.t_col2} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingTwo">
                                    <h6 className="m-0 font-14">
                                            Item #2 - Registration of remaining variables for all internment facilities: April 2024 <Badge color="info" className="mr-1">In Progress</Badge>
                                            <i className={this.state.col2 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                                </Link>
                                <Collapse isOpen={this.state.col2}>
                                        <CardBody>
                                            All remaining data points and data related facilities has to be finalized by the end of April 2024.
                                            Additionally the detailed information on XPCC will be gathered by the end of this project year.
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                            <Link to="#" onClick={this.t_col3} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingThree">
                                    <h6 className="m-0 font-14">
                                            Item #3 - Transfer all the remaining existing and new features from the old system: 31. July 2024 <Badge color="info" className="mr-1">In Progress</Badge>
                                            <i className={this.state.col3 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                            </Link>
                                <Collapse isOpen={this.state.col3}>
                                        <CardBody>
                                            The old features have to be developed for the AWS based system, including new features required to conduct daily activities.
                                            This includes development of dedicated pages for published books, 3d modelling.  
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                            <Link to="#" onClick={this.t_col4} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingFour">
                                    <h6 className="m-0 font-14">
                                            Item #4 - Transitional Justice Focus <Badge color="info" className="mr-1">In Progress</Badge>
                                            <i className={this.state.col4 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                            </Link>
                                <Collapse isOpen={this.state.col4}>
                                        <CardBody>
                                            The team will take into consideration transitional justice as an aspect and evaluate various international and legal bodies to build a dynamic pdf report that can be used for direct generation based on data and selection done by an analyst.
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                            <Link to="#" onClick={this.t_col5} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingFive">
                                    <h6 className="m-0 font-14">
                                            Item #5 - Register all list of demolished mosques in Qeshqer: 1. July 2024 <Badge color="danger" className="mr-1">Not Started</Badge>
                                            <i className={this.state.col5 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                            </Link>
                                <Collapse isOpen={this.state.col5}>
                                        <CardBody>
                                            The team already have registered mosques in the Ürümchi city. The next priority is to find all possible locations in Qeshqer region, but this one will depend on other high prioriy work.
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                            <Link to="#" onClick={this.t_col6} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingSix">
                                    <h6 className="m-0 font-14">
                                            Item #6 - Forced Labour: June 2023-2024 <Badge color="info" className="mr-1">In Progress</Badge>
                                            <i className={this.state.col6 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                            </Link>
                                <Collapse isOpen={this.state.col6}>
                                        <CardBody>
                                            The team will work on forced labour legasliation taking Norway as a case study to see effect of Transerancy Act Law and evidence collected by the UTJD to see possible link of products to forced labour.
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                            <Link to="#" onClick={this.t_col7} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingSeven">
                                    <h6 className="m-0 font-14">
                                            Item #7 - Seek possibility of co-launch of 3D project: 1. September - 1. December 2023 <Badge color="info" className="mr-1">In Progress</Badge>
                                            <i className={this.state.col7 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                            </Link>
                                <Collapse isOpen={this.state.col7}>
                                        <CardBody>
                                            We have already etsablished a good communication with Holocoust Museum in U.S.
                                            We will seek possibility of getting help from Holocoust Museum, Rafto and other possible organisations to launch our project in those countries. 
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                            <Link to="#" onClick={this.t_col8} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingEight">
                                    <h6 className="m-0 font-14">
                                            Item #8 - 3D Modelling work 1. July 2023 - 30. June 2024  <Badge color="info" className="mr-1">In Progress</Badge>
                                            <i className={this.state.col8 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                            </Link>
                                <Collapse isOpen={this.state.col8}>
                                        <CardBody>
                                            The 3D modelling came with the promised prototype for one of the camps. Now the team will finalize the work by creating all required and relevant models for the whole camp facility.
                                            Moreover in this period we will do our effort to launch it in different countries despite we do not have a dedicated funding for this. 
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                            <Link to="#" onClick={this.t_col9} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingNine">
                                    <h6 className="m-0 font-14">
                                            Item #9 - Untold Stories 1. July 2023 - 30. June 2024 <Badge color="danger" className="mr-1">Not Started</Badge>
                                            <i className={this.state.col9 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                            </Link>
                                <Collapse isOpen={this.state.col9}>
                                        <CardBody>
                                            The Untold Stories project will be conducted out of NED grant since it has not been funded. We will seek for possible fundings to be able to work on it.
                                        </CardBody>
                                </Collapse>
                            </Card>
                            <Card className="mb-0">
                                <Link to="#" onClick={this.t_col10} style={{ cursor: "pointer" }} className="text-dark" >
                                <CardHeader id="headingZero">
                                    <h6 className="m-0 font-14">
                                            Objectives - Objectives and evaluation points <Badge color="success" className="mr-1">Agreed</Badge>
                                            <i className={this.state.col10 ? "mdi mdi-minus float-right accor-plus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                    </h6>
                                </CardHeader>
                                </Link>
                                <Collapse isOpen={this.state.col10}>
                                        <CardBody>
                                            Objectives to deliver by UTJD for 2023-2024 project year
                                            <CardImg className="img-fluid" src={objectives} alt="Objectives for 2023-2024 project year" />
                                        </CardBody>
                                        
                                </Collapse>
                            </Card>
                        </div>
                    </CardBody>
                </Card>
            </Col>	
		);
	}
}

export default AccordionPlan;
